// Specialty page content - copywriting persuasivo para cada especialidade

export const SPECIALTY_CONTENT = {
  // ============================================================
  distonia: {
    slug: "distonia",
    label: "Distonia",
    breadcrumb: "Distonia",
    seo: {
      title:
        "Tratamento para Distonia | Dra. Luz Adriana — Distonia cervical, blefaroespasmo e mais",
      description:
        "Tratamento especializado para distonia cervical, blefaroespasmo e outras distonias focais com aplicação de Toxina Botulínica. Avaliação individualizada com a Dra. Luz Adriana.",
    },
    hero: {
      variant: "informative",
      overline: "Especialidade · Distonia",
      title: "Distonia",
      intro:
        "A distonia é um distúrbio neurológico do movimento no qual o cérebro envia sinais equivocados aos músculos, provocando <strong>contrações involuntárias e sustentadas</strong>. O resultado são posturas anormais, movimentos repetitivos e, muitas vezes, dor — que podem afetar uma única região do corpo (como o pescoço, os olhos ou a mão) ou grupos musculares mais amplos.",
      complementary:
        "Não é falta de controle. Não é “mania” ou frescura. É uma condição real, com base neurológica bem estabelecida — e que responde bem a um tratamento especializado quando conduzido corretamente.",
      symptomsTitle: "Principais sintomas",
      symptomsList: [
        "Contrações musculares involuntárias e sustentadas",
        "Posturas anormais ou movimentos repetitivos",
        "Torcicolo espasmódico (pescoço que vira sozinho)",
        "Fechamento involuntário das pálpebras (blefaroespasmo)",
        "Câimbra ao escrever ou tocar instrumentos",
        "Tremores e dor muscular associada",
      ],
      image:
        "https://images.unsplash.com/photo-1559757148-5c350d0d3c56?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
      imageCaption: "Distonia é uma condição neurológica — e tem tratamento.",
      ctaHero: "Falar com Especialista",
      indicators: [
        "Aplicação direcionada de Toxina Botulínica",
        "Mapeamento preciso dos músculos afetados",
        "Plano individualizado por tipo de distonia",
        "Acompanhamento contínuo dos resultados",
      ],
    },
    treatment: {
      overline: "Como podemos ajudar",
      titlePre: "Devolver ao corpo",
      titleItalic: "o controle que ele havia perdido",
      intro:
        "O tratamento da distonia com Toxina Botulínica é hoje uma das principais estratégias disponíveis: quando aplicada em pontos e doses corretas, ela reduz de forma seletiva a atividade dos músculos hiperativos, aliviando contrações, posturas anormais e a dor associada.",
      sparkleBox:
        "Quando a distonia recua, você recupera muito mais do que movimento: <strong>recupera o direito de estar em público sem ter que se esconder do próprio corpo</strong>.",
      benefits: [
        "Redução das contrações e espasmos involuntários",
        "Melhora da postura e do padrão de movimento",
        "Diminuição da dor associada à distonia",
        "Recuperação da autonomia em tarefas diárias",
        "Menor constrangimento em situações sociais",
        "Aplicação personalizada de Toxina Botulínica",
        "Acompanhamento contínuo com ajuste fino de doses",
      ],
      outro:
        "Cada distonia é única — cervical, blefaroespasmo, oromandibular, de mão, laríngea. O sucesso do tratamento depende de identificar, com precisão, quais músculos estão envolvidos no seu caso e ajustar cada aplicação à sua resposta clínica. Por isso, tudo começa com uma <strong>avaliação individualizada</strong>.",
    },
    finalCta: {
      overline: "Próximo passo",
      titlePre: "Você não precisa se esconder",
      titleItalic: "por causa da sua distonia",
      paragraphs: [
        "Contrações involuntárias, posturas anormais, tremores e o desgaste emocional que vem junto não são coisas para se “aprender a conviver”. São sinais de uma condição neurológica real, que merece avaliação criteriosa e tratamento especializado.",
        "Quanto antes o quadro é reconhecido e conduzido por um profissional experiente, maiores as chances de reduzir sintomas, prevenir posturas mantidas e preservar a sua funcionalidade.",
        "A avaliação é o primeiro passo para entender o tipo específico da sua distonia e desenhar um plano de aplicações realmente coerente com o que você vive.",
      ],
      closing:
        "Você merece um corpo que responda a você — e não o contrário.",
      bigCta: "Falar com Especialista",
    },
    ctaOptions: [],
  },

  // ============================================================
  espasticidade: {
    slug: "espasticidade",
    label: "Espasticidade",
    breadcrumb: "Espasticidade",
    seo: {
      title:
        "Tratamento para Espasticidade | Dra. Luz Adriana — Sequelas de AVC, TCE e reabilitação neurológica",
      description:
        "Tratamento da espasticidade com Toxina Botulínica: sequelas de AVC, TCE, esclerose múltipla, paralisia cerebral. Avaliação individualizada com a Dra. Luz Adriana.",
    },
    hero: {
      variant: "informative",
      overline: "Especialidade · Espasticidade",
      title: "Espasticidade",
      intro:
        "Espasticidade é o <strong>aumento do tônus muscular</strong> que aparece quando o sistema nervoso central sofre alguma lesão — como em sequelas de AVC, traumatismo craniano, esclerose múltipla, paralisia cerebral ou lesão medular. Os músculos ficam mais rígidos, resistem ao movimento e podem, com o tempo, gerar posturas fixas e dor.",
      complementary:
        "Ela não é preguiça, nem falta de esforço. É uma consequência neurológica real da lesão — e, tratada no tempo certo, pode ser controlada, aliviada e integrada ao processo de reabilitação.",
      symptomsTitle: "Principais sinais e sintomas",
      symptomsList: [
        "Rigidez muscular e resistência ao movimento",
        "Dificuldade para vestir, higienizar e alimentar",
        "Postura em flexão de braço, mão ou perna",
        "Marcha alterada e risco de quedas",
        "Contraturas e limitação articular progressiva",
        "Dor muscular e desconforto ao mobilizar",
      ],
      image:
        "https://customer-assets.emergentagent.com/job_consulta-enxaqueca/artifacts/ur07vbxb_Espasciticidade.jpeg",
      imageCaption: "Aplicação criteriosa de Toxina Botulínica em pontos-alvo.",
      ctaHero: "Falar com Especialista",
      indicators: [
        "Aplicação criteriosa de Toxina Botulínica",
        "Foco nos músculos-alvo do seu caso",
        "Integração com fisioterapia e reabilitação",
        "Acompanhamento próximo do paciente e da família",
      ],
    },
    treatment: {
      overline: "Como podemos ajudar",
      titlePre: "Reduzir o tônus muscular abre caminho",
      titleItalic: "para uma reabilitação mais efetiva",
      intro:
        "A aplicação de Toxina Botulínica em músculos-alvo é uma das principais estratégias no manejo da espasticidade. Ao reduzir de forma seletiva o tônus muscular exagerado, ela facilita a mobilização, o posicionamento e — sobretudo — <strong>o trabalho de fisioterapia</strong> que continua fazendo a diferença ao longo do tempo.",
      sparkleBox:
        "Cada movimento reconquistado importa. <strong>Vestir sozinho, dar um passo com mais confiança, permitir a higiene sem dor — pequenas vitórias que reconstroem grandes rotinas</strong>.",
      benefits: [
        "Redução do tônus muscular aumentado",
        "Alívio da rigidez e da dor associada",
        "Melhora do posicionamento e da postura",
        "Facilita a higiene, o vestir e os cuidados diários",
        "Prevenção de contraturas e deformidades",
        "Potencializa os ganhos da fisioterapia",
        "Cuidado que também acolhe a família e o cuidador",
      ],
      outro:
        "Cada quadro de espasticidade é diferente: causa, tempo de evolução, músculos envolvidos, objetivos funcionais. O tratamento precisa ser desenhado em conjunto com a equipe de reabilitação — por isso, o ponto de partida é sempre uma <strong>avaliação individualizada</strong>, coerente com o seu momento.",
    },
    finalCta: {
      overline: "Próximo passo",
      titlePre: "Reabilitação é um caminho",
      titleItalic: "e ele não precisa ser trilhado sozinho",
      paragraphs: [
        "Espasticidade não tratada tende a evoluir para posturas fixas, contraturas e limitações que dificultam ainda mais a reabilitação e o cuidado no dia a dia.",
        "Quando a Toxina Botulínica entra na estratégia, no momento certo e nas doses corretas, ela abre janelas terapêuticas para a fisioterapia e para os ganhos funcionais — devolvendo dignidade ao paciente e sustentação à família.",
        "A avaliação médica é o primeiro passo para desenhar, junto de você, um plano que dialogue com o seu histórico e com o seu momento de reabilitação.",
      ],
      closing:
        "Cada movimento reconquistado é uma vitória — e você não precisa conquistá-la sozinho.",
      bigCta: "Falar com Especialista",
    },
    ctaOptions: [],
  },

  // ============================================================
  enxaqueca: {
    slug: "enxaqueca",
    label: "Enxaqueca",
    breadcrumb: "Enxaqueca",
    seo: {
      title: "Tratamento para Enxaqueca | Dra. Luz Adriana — Especialista em Dor",
      description:
        "Tratamento especializado para enxaqueca crônica e dor de cabeça frequente. Avaliação individualizada com a Dra. Luz Adriana — recupere sua qualidade de vida.",
    },
    hero: {
      variant: "informative",
      overline: "Especialidade · Enxaqueca",
      title: "Enxaqueca",
      intro:
        "Enxaqueca é uma <strong>doença neurológica crônica</strong>, muito mais complexa do que uma dor de cabeça comum. As crises envolvem dor pulsátil (geralmente de um lado da cabeça), sensibilidade à luz, ao som e a cheiros, e podem vir acompanhadas de náuseas, vômitos e alterações visuais — impactando fortemente a rotina de trabalho, estudo, família e lazer.",
      complementary:
        "Não é frescura. Não é falta de café ou de sono. É uma condição real, com base biológica bem estabelecida — e que responde muito bem a um plano de tratamento individualizado quando conduzido por um profissional experiente.",
      symptomsTitle: "Principais sintomas",
      symptomsList: [
        "Dor de cabeça pulsátil, moderada a intensa",
        "Sensibilidade à luz, ao som e a cheiros",
        "Náuseas, tontura ou vômitos durante a crise",
        "Alterações visuais (aura) antes ou durante a dor",
        "Crises frequentes que atrapalham a rotina",
        "Cansaço, humor alterado e “ressaca” após a crise",
      ],
      image:
        "https://customer-assets.emergentagent.com/job_consulta-enxaqueca/artifacts/iu0yp5y0_Enxaqueca.jpeg",
      imageCaption: "Reduzir a dor devolve tempo, foco e presença ao seu dia.",
      ctaHero: "Falar com Especialista",
      indicators: [
        "Avaliação individualizada",
        "Investigação dos gatilhos",
        "Plano de tratamento personalizado",
        "Acompanhamento humanizado",
      ],
    },
    treatment: {
      overline: "Como podemos ajudar",
      titlePre: "Um acompanhamento especializado",
      titleItalic: "muda o curso da sua enxaqueca",
      intro:
        "O tratamento da enxaqueca vai muito além do analgésico de cada crise. Trata-se de entender o porquê das crises, mapear gatilhos, avaliar fatores associados e construir, em conjunto com você, um plano que devolva previsibilidade e leveza à sua rotina.",
      sparkleBox:
        "Quando você reduz a frequência e a intensidade das crises, você não está só tirando uma dor da sua vida — <strong>está colocando de volta tudo aquilo que a enxaqueca havia tirado</strong>.",
      benefits: [
        "Redução da frequência das crises",
        "Redução da intensidade da dor",
        "Menor dependência de analgésicos",
        "Identificação dos gatilhos das crises",
        "Tratamento personalizado para cada paciente",
        "Mais produtividade e qualidade de vida",
        "Recuperação da autonomia para viver sem medo da próxima crise",
      ],
      outro:
        "Cada paciente é único. A intensidade das suas crises, seus gatilhos, seu histórico clínico e o impacto da dor de cabeça frequente sobre a sua vida exigem <strong>uma avaliação individualizada</strong> — é nessa escuta cuidadosa que construímos o caminho do tratamento.",
    },
    finalCta: {
      overline: "Próximo passo",
      titlePre: "Conviver com dor de cabeça frequente",
      titleItalic: "não é normal",
      paragraphs: [
        "Crises recorrentes que limitam o trabalho, o estudo, a vida em família e os seus momentos de lazer pedem uma escuta clínica especializada — não mais um analgésico no fim do dia.",
        "Quanto mais cedo as causas das suas crises de enxaqueca são investigadas, maiores são as chances de reduzir o impacto da dor sobre a sua qualidade de vida — e devolver previsibilidade à sua rotina.",
        "A avaliação médica é o primeiro passo para compreender o que está, de fato, por trás das suas crises e construir um caminho terapêutico pensado exclusivamente para você.",
      ],
      closing:
        "Você merece acordar com a leveza de não ter medo do dia seguinte.",
      bigCta: "Falar com Especialista",
    },
    ctaOptions: [],
  },
};

export const getSpecialty = (slug) => SPECIALTY_CONTENT[slug] || null;
